import ucfirst from '../helpers/ucfirst'

export const connectToSession = {
    dataToSessionStorage (amount, amountList, paymentType, paymentMethod, paymentFormName, returnSuccessUrl, returnFailureUrl, returnSuccessUrlDirect, partnerName) {
        sessionStorage.setItem('amount', amount)
        sessionStorage.setItem('amount_list', JSON.stringify(amountList))
        sessionStorage.setItem('payment_type', paymentType)
        sessionStorage.setItem('payment_gateway', paymentMethod)
        sessionStorage.setItem('payment_form_name', paymentFormName)
        sessionStorage.setItem('client_data[return_success_url]', returnSuccessUrl)
        sessionStorage.setItem('client_data[return_failure_url]', returnFailureUrl)
        sessionStorage.setItem('client_data[return_success_url_direct]', returnSuccessUrlDirect)
        sessionStorage.setItem('partner_name', partnerName)
    },
    setNames (key, name) {
        return {
            get () {
                return this.$store.state[key]
            },
            set (value) {
                this.$store.commit('set' + ucfirst(key), value)
                sessionStorage.setItem(name, value)
            }
        }
    }
}
